<template>
  <div>
    <vx-card :title="$t('advisor-chat.schedule.title')"
      collapseAction refreshContentAction
    >
      <div id="simple-calendar-app">
        <!-- UPCOMING EVENT -->


        <!-- ACTIVE EVENT -->

        <div
          v-if="$data.$local.activeViewEvent"
          class="view-event"
          :title="$t('sections.liveschedule.detail-title')"
          :button-close-hidden="true"
        >
          <!-- CURRENT VIEW EVENT -->
          <vx-card>
            <div class="">
              <h5 class="">
                {{ $data.$local.currentViewEvent.data.topicLocal }}
              </h5>
              <p class="text-grey">
                {{ $data.$local.currentViewEvent.data.topicEng }}
              </p>
            </div>
            <div class="mb-6 mt-4">
              <h6>
                {{ $data.$local.currentViewEvent.data.subjectCode }}
                {{ $data.$local.currentViewEvent.data.subjectName }}
              </h6>

              {{ $t('general.teach-by') }} {{ $data.$local.currentViewEvent.data.teacherFullName }}
            </div>
            <vs-divider></vs-divider>
            <div class="flex justify-start flex-wrap">
              <span>
                <p class="text-xl">
                  {{ $t('general.live-start') }} {{ $data.$local.currentViewEvent.startDateFormat }}
                </p>
                <p class="text-grey">
                  {{ $t('general.live-end') }} {{ $data.$local.currentViewEvent.endDateFormat }}
                </p>
              </span>
            </div>
            <div
              class="mt-5 flex justify-end"
            >
              <vs-button
                v-if="checkCurrentLive($data.$local.currentViewEvent)"
                @click="viewLiveClass($data.$local.currentViewEvent.data)"
                class="mx-2 bg-success"
              >
                aem
                {{ $t('sections.liveschedule.view-liveclass') }}
              </vs-button>
              <vs-button
                @click="cancel"
                class="mx-2 bg-danger"
              >
                {{ $t('general.cancel') }}
              </vs-button>
            </div>
          </vx-card>

          <vs-divider></vs-divider>
        </div>

        <!-- CALENDAR -->

        <div class="no-scroll-content">
          <calendar-view
            ref="calendar"
            :displayPeriodUom="$data.$local.calendarView"
            :show-date="$data.$local.showDate"
            :events="$data.$local.calendarEvents"
            :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
            :startingDayOfWeek="1"
            eventBorderHeight="0px"
            eventContentHeight="1.65rem"
            class="calendar advisor-schedule theme-default"
            @click-event="onEventClick"
          >

            <div slot="header" class="mb-4">

              <div class="vx-row no-gutter">

                <!-- Month Name -->
                <div class="vx-col w-1/3 items-center sm:flex hidden">
                  <div class="flex items-center">
                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                      @click="updateMonth(-1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full" />

                    <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDateFormat | month }}</span>

                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                      @click="updateMonth(1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full" />
                  </div>
                </div>

                <!-- Current Month -->
                <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center">
                  <div></div>
                </div>

                <div class="vx-col sm:w-1/3 w-full flex justify-end order-last">
                  <template v-for="(view, index) in $data.$local.calendarViewTypes">
                    <vs-button
                      v-if="$data.$local.calendarView === view.val"
                      :key="String(view.val) + 'filled'"
                      type="filled"
                      class="p-3 md:px-8 md:py-3"
                      :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': $data.$local.calendarViewTypes.length !== index+1}"
                      @click="$data.$local.calendarView = view.val"
                      >{{ $t(`${view.i18n}`) }}</vs-button>

                    <vs-button
                      v-else
                      :key="String(view.val) + 'border'"
                      type="border"
                      class="p-3 md:px-8 md:py-3"
                      :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': $data.$local.calendarViewTypes.length !== index+1}"
                      @click="$data.$local.calendarView = view.val"
                      >{{ $t(`${view.i18n}`) }}</vs-button>
                  </template>

                </div>
              </div>

              <div class="vx-row sm:flex hidden mt-4">
                <div class="vx-col w-full flex">
                </div>
              </div>
            </div>

            <!-- <div slot="event" class="mb-5" slot-scope="e">
              {{ e.event.title }}

            </div> -->
            <div slot="dayContent" class="mb-5">

              <div slot="item" class="mb-5" slot-scope="val">
                {{ val }}
              </div>
            </div>


          </calendar-view>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import moment from "moment-timezone";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");

import Datepicker from "vuejs-datepicker";

import { state, prepare, refresh, cleanup } from "./data";
import { setActiveViewEvent } from "../../data";

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker
  },
  data() {
    return {
      $local: state.local
    }
  },
  //
  async created() {
    prepare();
  },
  //
  async mounted() {
    refresh();
  },
  //
  async beforeDestroy() {
    cleanup();
  },
  computed: {
    calendarEventList() {
      // return this.calendarEvents;
      // return state.local.events;
      return state.local.calendarEvents;
    },
    validForm() {
      return state.local.title != ''
        && state.local.startDate != ''
        && state.local.endDate != ''
        && (Date.parse(state.local.endDate) -     Date.parse(state.local.startDate)) >= 0
        && !state.local.errors.has('event-url');
    },
    disabledDatesTo() {
      return { to: new Date(state.local.startDate) }
    },
    disabledDatesFrom() {
      return { from: new Date(state.local.endDate) }
    },
    calendarLabels() {
      // return this.$store.state.calendar.eventLabels
      return state.local.eventLabels
    },
    labelColor() {
      return (label) => {
        if (label == "business") return "success"
        else if (label == "work") return "warning"
        if (label == "personal") return "danger"
        if (label == "none") return "primary"
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    currentLocale() {
      return this.$store.state["currentLocale"];
    },
    showDateFormat() {
      moment.locale(this.currentLocale);
      return moment(state.local.showDate);
    }
  },
  methods: {
    onEventClick(event) {
      setActiveViewEvent(event);
    },
    addEvent() {
        const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
        obj.classes = "event-" + this.labelColor(this.labelLocal)
    },
    updateMonth(val) {
      state.local.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    clearFields() {
        this.title = this.endDate = this.url = "";
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
        this.clearFields();
        this.startDate = date;
        this.endDate = date;
        this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
        this.disabledFrom = true;
        this.addNewEventDialog(date);
    },
    openEvent(evt) {
      const event = this.mapSingleLiveclassToEvent(this.liveClasses.find(liveclass => liveclass.id === evt.id));
      this.currentViewEvent = { ...event };
      this.activeViewEvent = true;
    },
    closeEventViewer() {
      this.activeViewEvent = false;
    },
    openEditEvent(event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true;
    },
    editEvent() {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    },
    mapLiveClassesToCalendar(liveclasses) {
      return liveclasses.map(liveclass => {
        return this.mapSingleLiveclassToEvent(liveclass);
      })
    },
    mapSingleLiveclassToEvent(liveclass) {
      moment.locale(this.currentLocale);

      const id = liveclass.id;
      const startDate = moment(new Date(liveclass.dateTimeFrom));
      const endDate = moment(new Date(liveclass.dateTimeTo));
      const title = liveclass.subjectCode;
      const url = "";
      const data = liveclass;
      const cssClasses = "";

      return {
        id,
        startDate,
        endDate,
        startDateFormat: startDate.format("LLLL"),
        endDateFormat: endDate.format("LLLL"),
        title,
        url,
        classes: cssClasses,
        data,
      }
    },
    checkCurrentLive(currentViewEvent) {
      if (currentViewEvent) {
        const currentPosixTime = new Date().getTime() / 1000;
        const eventStartDate = new Date(currentViewEvent.startDate).getTime() / 1000;
        const eventEndDate = new Date(currentViewEvent.endDate).getTime() / 1000;

        return currentPosixTime >= eventStartDate || currentPosixTime <= eventEndDate ? true : false;
      }
      return false;
    },
    viewLiveClass(liveClassData) {
      this.activeViewEvent = false;
      this.$store.dispatch("LiveClass/viewLiveClass", liveClassData, { root: true });
      this.$router.push('/e-learning/live-class');
    },
    cancel() {
      this.activeViewEvent = false;
    }
  },
}
</script>

<style lang="scss">
@import "../../schedule.scss";
</style>
